module.exports = __webpack_public_path__ + "@/assets/img/MA-5000-white.536140df.jpg";